import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';

const CreateInventoryDialog = ({ open, onOpenChange, sites, formNom, setFormNom, formSiteId, setFormSiteId, formDescription, setFormDescription, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader><DialogTitle>Nouvel inventaire</DialogTitle></DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label>Nom de l&apos;inventaire *</Label>
          <Input
            value={formNom}
            onChange={(e) => setFormNom(e.target.value)}
            placeholder="Ex: Inventaire Q1 2024"
            required
            data-testid="input-inventory-name"
          />
        </div>
        <div className="space-y-2">
          <Label>Site *</Label>
          <Select value={formSiteId} onValueChange={setFormSiteId} required>
            <SelectTrigger data-testid="select-inventory-site">
              <SelectValue placeholder="Sélectionner un site" />
            </SelectTrigger>
            <SelectContent>
              {sites.map(site => <SelectItem key={site.id} value={site.id}>{site.nom}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Description</Label>
          <Textarea
            value={formDescription}
            onChange={(e) => setFormDescription(e.target.value)}
            placeholder="Notes..."
            rows={3}
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button type="submit" className="bg-blue-600 hover:bg-blue-700" data-testid="create-inventory-btn">Créer</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export default CreateInventoryDialog;
